import React from 'react';
import { List, ListItem } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { ActiveLink } from './components/ActiveLink';
export const Navigation = ({ items }) => {
    const { pathname } = useLocation();
    return (React.createElement(List, null, items.map(({ href, name }) => (React.createElement(ListItem, { key: name },
        React.createElement(ActiveLink, { key: href, href: href, name: name, isActive: pathname === href }))))));
};
